import React from 'react';
import LessonListItemView from './LessonListItemView';
import { FavoriteItem, Identifier } from '../../types';

interface Props {
    items: Array<FavoriteItem>,
    iconColor: string,
    className: string,
    onRemoveClicked: (lessonId: Identifier) => any,
}

const LessonList: React.FunctionComponent<Props> = ({ items, iconColor, className, onRemoveClicked }: Props) => (
    <div className={className}>
        {items.map(item => (
            <LessonListItemView
                key={item.lessonId}
                item={item}
                iconColor={iconColor}
                onRemoveClicked={() => onRemoveClicked(item.lessonId)}
            />
        ))}
    </div>
);

export default LessonList;
